import jwtAxios from '@crema/services/auth/jwt-auth';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  UPDATE_DATATABLE_TABLE_INFO,
  SHOW_MESSAGE,
  GET_DEPARTMENT_DETAIL_ADMINTOOLS,
  GET_DEPARTMENT_OPTIONS,
} from 'shared/constants/ActionTypes';
import {API} from 'shared/constants/AppEnums';
import {updateRows} from './dataTable';

export const onGetListDepartmentAdmintools = (
  limit = 10,
  page = 0,
  search = '',
) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    let url =
      API.GET_DEPARTMENT_MASTER_DATA +
      `?limit=${limit}&offset=${page * limit}&search=${search}&type=active`;

    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: UPDATE_DATATABLE_TABLE_INFO, payload: data.data});
          const grouped = {};
          for (const obj of data.data.results) {
            const key = obj['division_name'];
        
            if (!grouped[key]) {
              grouped[key] = [];
            }
        
            grouped[key].push(obj);
          }
          let arr = data.data.results
          const propertyNames = Object.keys(grouped);
          propertyNames.forEach((item,index)=>{
              arr.push(
                {
                  "pkid": '',
                  "show": true,
                  "hierarchy": item,
                  "division_name": item,
                  "id": index,
                  "is_delete": false,
                  "created_at": "2023-06-16T19:43:26.754709",
                  "updated_at": "2023-06-16T19:43:26.754729",
                  "code": "",
                  "abbreviation": "",
                  "name": item,
                  "short_name": null,
                  "division": 9,
                  "parent": []
              }
              )
          })
          arr.sort((a, b) => {
            const nameComparison = a.division_name.localeCompare(b.division_name); // Compare by 'name' property
            if (nameComparison !== 0) {
              return nameComparison; // If names are different, return the result
            }
            
            // If names are the same, compare by 'id' property
            return a.pkid - b.pkid;
          });
          console.log(arr)
          dispatch(updateRows(data.data.results));
        } else {
          dispatch({type: FETCH_ERROR, payload: data.data});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error});
      });
  };
};

export const onGetDetailDepartmentAdmintools = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    let url = API.GET_DEPARTMENT_MASTER_DATA+id+"/"


    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        console.log(data)
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({type:GET_DEPARTMENT_DETAIL_ADMINTOOLS,payload:data.data.results})
        } else {

          dispatch({ type: FETCH_ERROR, payload: data.data })
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }
}

export const onGetDetailDepartmentByDivision = (division) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    let url = API.GETSATKERBYUNKER.replace('$id',division)
  


    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        console.log(data)
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({type:GET_DEPARTMENT_OPTIONS,payload:data.data.results})
        } else {

          dispatch({ type: FETCH_ERROR, payload: data.data })
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }
}

export const onDeleteDepartment = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    let url = API.GET_DEPARTMENT_MASTER_DATA + id + '/';

    jwtAxios
      .delete(url, API.requestOptionsDELETE())
      .then((data) => {
        if (data.status === 200 || data.status === 201) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: 'Unit Kerja Berhasil Dihapus',
          });
        } else {
          dispatch({type: FETCH_ERROR, payload: data.data});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error});
      });
  };
};

export const onGetDepartmentAutoComplete = (inputVal) => {

  return (dispatch) => {
  let url = API.GET_DEPARTMENT_MASTER_DATA + `?search=${inputVal}`;

  jwtAxios
    .get(url, API.requestOptionsGET())
    .then((data) => {
      if (data.status === 200) {
        dispatch({type: FETCH_SUCCESS});
        let opt = data.data.results.map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
        console.log(opt)
        dispatch({type:GET_DEPARTMENT_OPTIONS,payload:opt})
      } else {
        dispatch({type: FETCH_ERROR, payload: data.data});
      }
    })
    .catch((error) => {
      dispatch({type: FETCH_ERROR, payload: error});
    });
  }
};

export const onCreateDepartment = (bodyReq) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    let url = API.GET_DEPARTMENT_MASTER_DATA

    jwtAxios
      .post(url,bodyReq, API.requestOptionsPOST())
      .then((data) => {
        if (data.status === 200 || data.status === 201) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: SHOW_MESSAGE, payload: 'Unit Kerja Berhasil Ditambahkan' });

        } else {

          dispatch({ type: FETCH_ERROR, payload: data.data })
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }

  
}  

export const onUpdateDepartment = (bodyReq,id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    let url = API.GET_DEPARTMENT_MASTER_DATA+"/"+id+"/"

    jwtAxios
      .put(url,bodyReq, API.requestOptionsPUT())
      .then((data) => {
        if (data.status === 200 || data.status === 201) {
          dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: SHOW_MESSAGE, payload: 'Unit Kerja Berhasil Diubah' });

        } else {

          dispatch({ type: FETCH_ERROR, payload: data.data })
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }
}
